import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { VERSION } from '../../app.constants';
import { SessionQuery } from '../../core/state/session.query';
import { User } from '../../shared/model/user.model';
import { SessionService } from '../../core/state/session.service';
import { Authority } from '../../core/model/authority.model';
import { AppConfiguration } from '../../shared/model/app-configuration.model';
import { ProjectService } from '../../shared/service/project.service';
import { HttpResponse } from '@angular/common/http';
import { AppVersion } from 'src/app/shared/model/appVersion.model';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbCollapse, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';

@Component({
    selector: 'mgp-navbar',
    // imports: [
    //     FontAwesomeModule,
    //     RouterModule,
    //     NgbCollapseModule,
    //     NgbDropdownModule
    // ],
    templateUrl: './navbar.component.html',
    imports: [RouterLink, FaIconComponent, NgbCollapse, RouterLinkActive, NgIf, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu]
})
export class NavbarComponent implements OnInit{
    isNavbarCollapsed = true;
    version = '';

    authorities = Authority;

    account: User | null = null;
    isAdmin = false;

    isReferent = false;

    appVersion = "Versione Software BackEnd ";

    constructor(
        private router: Router,
        private sessionQuery: SessionQuery,
        private sessionService: SessionService,
        private projectService: ProjectService,
        public appConfiguration: AppConfiguration) {
        if (VERSION) {
            this.version = VERSION.toLowerCase().startsWith('v') ? VERSION : `v${VERSION}`;
        }
    }

    ngOnInit(): void {

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.projectService.getApplicationVersion().subscribe((data: HttpResponse<AppVersion>) => {
        this.appVersion = 'Versione Software BackEnd 1.0.37';
        // this.appVersion += data.body?.appVersion;
        this.sessionQuery.selectUser$.subscribe((user: User | null) => {
            this.account = user;
            // Ricomincio da capo
            this.isAdmin = this.sessionQuery.hasAnyAuthority(Authority.ROLE_ADMIN);
            this.isReferent = this.sessionQuery.hasAnyAuthority(Authority.ROLE_REFERENTE_ENTE);
            // Ticket-OSCAT# 202403274100026 Supporto OSCAT
            if ((this.appConfiguration.oscatUrl.includes('test') || (this.appConfiguration.oscatUrl.includes('local') ))){
                this.appConfiguration.oscatUrl = 'https://oscat-test.regione.toscana.it'
            } else {
                this.appConfiguration.oscatUrl = 'https://oscat.regione.toscana.it'
            }
        })
    });
    }

    collapseNavbar(): void {
        this.isNavbarCollapsed = true;
    }

    toggleNavbar(): void {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    logout(type: string): void {
        if(type === 'cookie') {
            this.sessionService.logoutCookie();
        } else {
            this.sessionService.logoutGitlab();
        }
        
    }
}